import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const HintsContext = createContext(null);

export function HintsProvider({ children }) {
  const [enabled, setEnabled] = useState(() => {
    const v = localStorage.getItem('sp_hints');
    return v === null ? true : v === '1';
  });

  useEffect(() => {
    localStorage.setItem('sp_hints', enabled ? '1' : '0');
  }, [enabled]);

  const toggle = useCallback(() => setEnabled(v => !v), []);

  return (
    <HintsContext.Provider value={{ enabled, setEnabled, toggle }}>
      {children}
    </HintsContext.Provider>
  );
}

export const useHints = () => useContext(HintsContext);
